<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-2" d="m29.66,30c-.22,0-.39-.18-.39-.39v-3.42c0-.22.18-.39.39-.39s.39.18.39.39v3.42c0,.22-.18.39-.39.39Z"/>
  <g>
    <line class="cls-4" x1="16.36" y1="31.7" x2="17.66" y2="32.99"/>
    <path class="cls-2" d="m17.66,33.39c-.1,0-.2-.04-.28-.11l-1.3-1.3c-.15-.15-.15-.4,0-.55s.4-.15.55,0l1.3,1.3c.15.15.15.4,0,.55-.08.08-.18.11-.28.11Z"/>
  </g>
  <g>
    <line class="cls-4" x1="10.85" y1="45" x2="14.27" y2="45"/>
    <path class="cls-2" d="m14.27,45.39h-3.42c-.22,0-.39-.18-.39-.39s.18-.39.39-.39h3.42c.22,0,.39.18.39.39s-.18.39-.39.39Z"/>
  </g>
  <g>
    <line class="cls-4" x1="16.92" y1="57.74" x2="18.22" y2="56.44"/>
    <path class="cls-2" d="m16.92,58.13c-.1,0-.2-.04-.28-.11-.15-.15-.15-.4,0-.55l1.3-1.3c.15-.15.4-.15.55,0s.15.4,0,.55l-1.3,1.3c-.08.08-.18.11-.28.11Z"/>
  </g>
  <g>
    <line class="cls-4" x1="29.66" y1="63.81" x2="29.66" y2="60.39"/>
    <path class="cls-2" d="m29.66,64.21c-.22,0-.39-.18-.39-.39v-3.42c0-.22.18-.39.39-.39s.39.18.39.39v3.42c0,.22-.18.39-.39.39Z"/>
  </g>
  <g>
    <line class="cls-4" x1="42.41" y1="57.74" x2="41.11" y2="56.44"/>
    <path class="cls-2" d="m42.41,58.13c-.1,0-.2-.04-.28-.11l-1.3-1.3c-.15-.15-.15-.4,0-.55s.4-.15.55,0l1.3,1.3c.15.15.15.4,0,.55-.08.08-.18.11-.28.11Z"/>
  </g>
  <g>
    <line class="cls-4" x1="10.85" y1="45" x2="14.27" y2="45"/>
    <path class="cls-2" d="m14.27,45.39h-3.42c-.22,0-.39-.18-.39-.39s.18-.39.39-.39h3.42c.22,0,.39.18.39.39s-.18.39-.39.39Z"/>
  </g>
  <g>
    <line class="cls-4" x1="29.66" y1="63.81" x2="29.66" y2="60.39"/>
    <path class="cls-2" d="m29.66,64.21c-.22,0-.39-.18-.39-.39v-3.42c0-.22.18-.39.39-.39s.39.18.39.39v3.42c0,.22-.18.39-.39.39Z"/>
  </g>
  <g>
    <polygon class="cls-1" points="34.34 33.11 29.65 45 17.56 50.59 34.34 33.11"/>
    <path class="cls-3" d="m17.56,51.77c-.44,0-.87-.25-1.07-.68-.27-.59-.02-1.29.57-1.56l11.67-5.39,4.52-11.45c.24-.6.92-.9,1.53-.66s.9.92.66,1.53l-4.86,12.33-12.52,5.79c-.16.07-.33.11-.49.11Z"/>
  </g>
  <path class="cls-3" d="m60.33,30c-.22,0-.39-.18-.39-.39v-3.42c0-.22.18-.39.39-.39s.39.18.39.39v3.42c0,.22-.18.39-.39.39Z"/>
  <g>
    <path class="cls-2" d="m47.3,28.66c-.72-.78-1.49-1.5-2.3-2.17-.82.67-1.59,1.4-2.31,2.18.82.64,1.6,1.36,2.31,2.14,3.47,3.73,5.58,8.72,5.58,14.2s-2.11,10.45-5.58,14.19c.7.78,1.47,1.5,2.3,2.15,3.98-4.29,6.42-10.04,6.42-16.34s-2.44-12.05-6.42-16.34Z"/>
    <path class="cls-3" d="m60.34,20.95c-5.83,0-11.17,2.08-15.33,5.54-.82.67-1.59,1.4-2.31,2.18-3.98,4.29-6.42,10.03-6.42,16.34s2.43,12.04,6.42,16.33c.82-.64,1.6-1.36,2.31-2.14-3.47-3.73-5.58-8.71-5.58-14.19s2.11-10.46,5.58-14.2c.7-.78,1.47-1.5,2.3-2.15,3.58-2.86,8.1-4.57,13.03-4.57,11.53,0,20.92,9.38,20.92,20.92s-9.39,20.91-20.92,20.91c-4.93,0-9.46-1.71-13.03-4.57-.72.78-1.49,1.5-2.3,2.17,4.16,3.46,9.51,5.54,15.33,5.54,13.26,0,24.05-10.78,24.05-24.05s-10.79-24.05-24.05-24.05Z"/>
    <path class="cls-2" d="m47.3,61.34c-.72.78-1.49,1.5-2.3,2.17-4.17,3.46-9.52,5.54-15.34,5.54-13.26,0-24.05-10.78-24.05-24.05s10.79-24.05,24.05-24.05c5.82,0,11.17,2.08,15.34,5.54-.82.67-1.59,1.4-2.31,2.18-3.58-2.87-8.11-4.58-13.03-4.58-11.53,0-20.92,9.38-20.92,20.92s9.39,20.91,20.92,20.91c4.93,0,9.46-1.71,13.03-4.58.82-.64,1.6-1.36,2.31-2.14.7.78,1.47,1.5,2.3,2.15Z"/>
  </g>
  <g>
    <line class="cls-4" x1="47.59" y1="57.74" x2="48.89" y2="56.44"/>
    <path class="cls-2" d="m47.59,58.13c-.1,0-.2-.04-.28-.11-.15-.15-.15-.4,0-.55l1.3-1.3c.15-.15.4-.15.55,0s.15.4,0,.55l-1.3,1.3c-.08.08-.18.11-.28.11Z"/>
  </g>
  <g>
    <line class="cls-4" x1="60.33" y1="63.81" x2="60.33" y2="60.39"/>
    <path class="cls-2" d="m60.33,64.21c-.22,0-.39-.18-.39-.39v-3.42c0-.22.18-.39.39-.39s.39.18.39.39v3.42c0,.22-.18.39-.39.39Z"/>
  </g>
  <g>
    <line class="cls-3" x1="73.08" y1="57.74" x2="71.78" y2="56.44"/>
    <path class="cls-3" d="m73.08,58.13c-.1,0-.2-.04-.28-.11l-1.3-1.3c-.15-.15-.15-.4,0-.55s.4-.15.55,0l1.3,1.3c.15.15.15.4,0,.55-.08.08-.18.11-.28.11Z"/>
  </g>
  <g>
    <line class="cls-4" x1="79.15" y1="45" x2="75.73" y2="45"/>
    <path class="cls-2" d="m79.15,45.39h-3.42c-.22,0-.39-.18-.39-.39s.18-.39.39-.39h3.42c.22,0,.39.18.39.39s-.18.39-.39.39Z"/>
  </g>
  <g>
    <line class="cls-3" x1="73.08" y1="31.7" x2="71.78" y2="33"/>
    <path class="cls-3" d="m71.78,33.39c-.1,0-.2-.04-.28-.11-.15-.15-.15-.4,0-.55l1.3-1.3c.15-.15.4-.15.55,0s.15.4,0,.55l-1.3,1.3c-.08.08-.18.11-.28.11Z"/>
  </g>
  <g>
    <line class="cls-3" x1="60.33" y1="63.81" x2="60.33" y2="60.39"/>
    <path class="cls-3" d="m60.33,64.21c-.22,0-.39-.18-.39-.39v-3.42c0-.22.18-.39.39-.39s.39.18.39.39v3.42c0,.22-.18.39-.39.39Z"/>
  </g>
  <g>
    <line class="cls-3" x1="79.15" y1="45" x2="75.73" y2="45"/>
    <path class="cls-3" d="m79.15,45.39h-3.42c-.22,0-.39-.18-.39-.39s.18-.39.39-.39h3.42c.22,0,.39.18.39.39s-.18.39-.39.39Z"/>
  </g>
  <path class="cls-2" d="m72.43,51.77c-.17,0-.33-.03-.49-.11l-12.52-5.79-4.86-12.33c-.24-.6.06-1.29.66-1.53.61-.24,1.29.06,1.53.66l4.51,11.45,11.67,5.39c.59.27.85.97.57,1.56-.2.43-.62.68-1.07.68Z"/>
</svg>
</template>

<script>
export default {
    name: "TimeCombinedTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: none;
  }
</style>